import { Box } from "@bca/ui-library";
import React from "react";

import { showMoreOptions } from "./filtersConfig";
import ToggleVisibleFiltersButton from "./ToggleVisibleFiltersButton";

const ShowMoreButton = ({
  categoryKey,
  filteredSubfilters,
  sliceSize,
  setSliceSize,
  setRefreshCollapsible,
}) => {
  return (
    <>
      {Boolean(showMoreOptions[categoryKey]) && (
        <Box>
          {sliceSize === showMoreOptions[categoryKey]?.visibleOptionsCount &&
            filteredSubfilters?.length >
              showMoreOptions[categoryKey]?.visibleOptionsCount && (
              <ToggleVisibleFiltersButton
                onClick={() => {
                  setSliceSize(filteredSubfilters?.length);
                  setRefreshCollapsible(filteredSubfilters?.length);
                }}
                text={`Show more ${showMoreOptions[categoryKey].label}`}
              />
            )}

          {sliceSize === filteredSubfilters?.length &&
            filteredSubfilters?.length >
              showMoreOptions[categoryKey]?.visibleOptionsCount && (
              <ToggleVisibleFiltersButton
                onClick={() => {
                  setSliceSize(
                    showMoreOptions[categoryKey]?.visibleOptionsCount
                  );
                  setRefreshCollapsible(
                    showMoreOptions[categoryKey]?.visibleOptionsCount
                  );
                }}
                text={`Show less ${showMoreOptions[categoryKey].label}`}
              />
            )}
        </Box>
      )}
    </>
  );
};

export default ShowMoreButton;
